import React, { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import TopHeader from "../../Components/TopHeader";
import Prince from "../../Components/Prince";


import { useLocation, useNavigate } from "react-router-dom";

import DateFormatter from "../Common/CustomDatePicker";

import * as b2bleadService from "../../Services/b2bleadService"
import TablePagination from "../Common/newTablePagination";
import Loader from "../../assets/img/loader.gif";
import AddB2BLeadModal from "./addb2bnewLead";
import { B2BAssignToKamModel } from "./assigntoKamModal";
import B2BBulkAssignModal from "./b2bbulkAssign";
import B2BBulkLeadSoureModal from "./b2bbulkLeadSource";
import B2BBulkStageModal from "./b2bbulkStage";
import B2BBulkPipelineModal from "./b2bbulkpipeline";
import EditB2BLeadModal from "./editb2bLead";
import B2BAssignModal from "./b2bsingelAssign";
import B2BLeadLifeCycleModal from "./b2bleadlifeCycle";
import B2BStageModal from "./b2bsingelStage";
import B2BExportModalComponent from "./b2bexportModal";
import { DataContext } from "../../context/DataContext";



export const B2BSalesCRM = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [activeTab, setActiveTab] = useState("new");
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const addLeadModalRef = useRef(null);
    const bulkAssignModalRef = useRef(null);
    const bulkleadsourceModalRef = useRef(null);
    const bulkstageModalRef = useRef(null);
    const bulkpipelineModalRef = useRef(null);
    const editLeadModalRef = useRef(null);
    const assignModalRef = useRef(null);
    const stageModalRef = useRef(null);
    const b2cexportModalRef = useRef(null);
    const leadlifecycleModalRef = useRef(null);
    const assigntokamRef = useRef(null);
    const [dateFilter, setDateFilter] = useState({});
    const [clearDate, setClearDate] = useState(false);
    const [utmSourceOptions, setUtmSourceOptions] = useState([]);
    const [selectedSource, setSelectedSource] = useState([]);
    const [utmMediumOptions, setUtmMediumOptions] = useState([]);
    const [selectedMedium, setSelectedMedium] = useState([]);
    const [utmCampaignOptions, setUtmCampaignOptions] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState([]);
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectedLeadSource, setSelectedLeadSource] = useState([]);
    const [leadPipelineOptions, setLeadPipelineOptions] = useState([]);
    const [selectedPipeline, setSelectedPipeline] = useState([]);
    const [businessCategoryOptions, setBusinessCategoryOptions] = useState([]);
    const [selectedBusinessCategory, setSelectedBusinessCategory] = useState([]);
    const [shippingPartnerOptions, setShippingPartnerOptions] = useState([]);
    const [selectedShippingPartner, setSelectedShippingPartner] = useState([]);
    const [shipmentPotentialOptions, setShipmentPotentialOptions] = useState([]);
    const [selectedShipmentPotential, setSelectedShipmentPotential] = useState([]);
    const [clientPersonaOptions, setClientPersonaOptions] = useState([]);
    const [selectedClientPersona, setSelectedClientPersona] = useState([]);
    const [leadOwnerOptions, setLeadOwnerOptions] = useState([]);
    const [selectedLeadOwner, setSelectedLeadOwner] = useState([]);
    const [kycOptions, setKycOptions] = useState([]);
    const [selectedKyc, setSelectedKyc] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [employees, setEmployees] = useState({});
    const result = useContext(DataContext);
    const [employeeData, setEmployee] = useState({});
    useEffect(() => {
        setEmployee(result.employeeData);
    }, [result.employeeData]);

    const allowedEmails = [
        "raushan@fship.in",
        "raju.sinha@fship.in",
        "mukund@fship.in",
        "vikas.yadav@fship.in",
    ];

    const canExport = allowedEmails.includes(employeeData?.email);


    // for filter 
    const [filters, setFilters] = useState({

        search: "",

        accountType: "",
        leadType: "",

        leadSource: [],
        leadPipeline: [],
        businessCategory: [],
        currentShippingPartner: [],
        shipmentPotential: [],
        clientPersona: [],
        employeeId: [],
        isKycDone: [],

        utmSource: [],
        utmMedium: [],
        utmCampaign: [],

        minimumExpectedShipmentToFship: "",

        genericEmailPattern: "",

        from: "",
        to: "",

    });


    const handleApplyFilter = () => {

        setCurrentPage(1);

        getLeadData();

    };

    const handleClearFilter = () => {

        setClearDate(!clearDate);

        const clearedFilters = {

            search: "",

            accountType: "",
            leadType: "",

            leadSource: [],
            leadPipeline: [],
            businessCategory: [],
            currentShippingPartner: [],
            shipmentPotential: [],
            clientPersona: [],
            employeeId: [],
            isKycDone: [],

            utmSource: [],
            utmMedium: [],
            utmCampaign: [],

            minimumExpectedShipmentToFship: "",

            genericEmailPattern: "",

            from: "",
            to: "",
        };

        setFilters(clearedFilters);

        setCurrentPage(1);

        // direct cleared state bhejo
        getLeadData(clearedFilters);
    };






    // const tableData = [
    //     { id: 123, name: "John Doe" },
    //     { id: 124, name: "Jane Doe" },
    //     { id: 125, name: "Alex" },
    // ];

    // Single Checkbox
    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedLeads((prev) => [...prev, id]);
        } else {
            setSelectedLeads((prev) =>
                prev.filter((item) => item !== id)
            );
        }
    };
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = tableData.map((item) => item.id);

            setSelectedLeads(allIds);
        } else {
            setSelectedLeads([]);
        }
    };
    // Tabs
    const tabs = [
        { label: "New", value: "new" },
        { label: "Call Attempted", value: "call-attempted" },
        { label: "Contact in future", value: "contact-in-future" },
        { label: "Follow-up", value: "follow-up" },
        { label: "Proposal", value: "proposal" },
        { label: "Negotiation", value: "negotiation" },
        { label: "In-Integration", value: "integration-inprogress" },
        { label: "Shipment yet to Start (Closed/Won)", value: "closed-won-SYTS" },
        { label: "Won", value: "won" },
        { label: "Lost", value: "lost" },

        { label: "All", value: "Open" },
    ];

    const handleTabClick = (value) => {
        if (loader) return;
        setSelectedLeads([]); // RESET
        setActiveTab(value);

        // console.log("Tab:", value);
        //  API call here
    };

    // react-select styles
    const customSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: "40px",
            borderRadius: "5px",
        }),
    };

    // for table pagination 

    const [currentPage, setCurrentPage] =
        useState(1);

    const [pageSize, setPageSize] =
        useState(20);

    const totalPages = Math.ceil(
        totalCount / pageSize
    );

    const handlePageChange = (page) => {

        setCurrentPage(page);

    };

    const handlePageSize = (size) => {

        setPageSize(size);

        setCurrentPage(1);

    };



    useEffect(() => {

        if (location?.state?.activeTab) {

            setActiveTab(location.state.activeTab);

        }

    }, [location]);







    // this useEffect only for filter dropdown 


    useEffect(() => {

        getutmfilter();
        getLeadSource();
        getleadpipelineoptions();
        getbusinessCategory();
        getshippingParnter();
        getshipmentPotenical();
        getclientpersona();
        getleadOwner();
        getkyc();
        getEmployeesData();
        // getEmployee();
    }, []);

    // this useEffect is only use for getalllead

    useEffect(() => {

        getLeadData();
        setSelectedLeads([]);

    }, [
        activeTab,
        currentPage,
        pageSize,
    ]);



    // All Api Call 

    // const getEmployee = async () => {
    //     try {
    //         const res = await b2cleadService.getEmployee();

    //         if (res?.data?.status === "success") {
    //             setEmployee(res?.data?.data);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const getEmployeesData = async () => {

        try {

            const res =
                await b2bleadService.getEmployees();

            if (
                res?.data?.status === "success"
            ) {

                setEmployees(
                    res?.data?.data || []
                );

            }

        } catch (error) {

            // console.log(
            //     "EMPLOYEE ERROR",
            //     error
            // );

        }

    };

    const getLeadData = (customFilters = filters) => {

        setLoader(true);
        const payload = {

            search: customFilters.search,

            // accountType: "B2C",
            accountType: customFilters.accountType || "B2B_PAGE",
            leadType: customFilters.leadType,

            leadSource:
                customFilters.leadSource
                    .map((i) => i.value)
                    .join(","),

            leadPipeline:
                customFilters.leadPipeline
                    .map((i) => i.value)
                    .join(","),

            businessCategory:
                customFilters.businessCategory
                    .map((i) => i.value)
                    .join(","),

            currentShippingPartner:
                customFilters.currentShippingPartner
                    .map((i) => i.value)
                    .join(","),

            shipmentPotential:
                customFilters.shipmentPotential
                    .map((i) => i.value)
                    .join(","),

            clientPersona:
                customFilters.clientPersona
                    .map((i) => i.value)
                    .join(","),

            employeeId:
                customFilters.employeeId
                    .map((i) => i.value)
                    .join(","),

            isKycDone:
                customFilters.isKycDone
                    .map((i) => i.value)
                    .join(","),

            utmSource:
                customFilters.utmSource
                    .map((i) => i.value)
                    .join(","),

            utmMedium:
                customFilters.utmMedium
                    .map((i) => i.value)
                    .join(","),

            utmCampaign:
                customFilters.utmCampaign
                    .map((i) => i.value)
                    .join(","),

            minimumExpectedShipmentToFship:
                customFilters.minimumExpectedShipmentToFship,

            genericEmailPattern:
                customFilters.genericEmailPattern,

            from: customFilters.from,
            to: customFilters.to,

            page: currentPage,
            pageSize,
        };


        // ALL TAB
        const apiCall =
            activeTab === "Open"

                ? b2bleadService
                    .getAllMasterLead(
                        activeTab,
                        payload
                    )

                : b2bleadService
                    .getAllLead(
                        activeTab,
                        payload
                    );

        apiCall

            .then((res) => {

                if (
                    res?.data?.status ===
                    "success"
                ) {

                    setTableData(
                        res?.data?.data || []
                    );

                    setTotalCount(
                        res?.data?.totalCount || 0
                    );

                }

            })

            .catch((error) => {

                // console.log(
                //     "TABLE API ERROR",
                //     error
                // );

            })

            .finally(() => {

                setLoader(false);

            });

    };

    const getLeadSource = () => {

        b2bleadService
            .leadSource()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setLeadSourceOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "LEAD SOURCE ERROR",
                //     error
                // );

            });

    };
    const getleadpipelineoptions = () => {

        b2bleadService
            .leadpipelineoptions()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setLeadPipelineOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "PIPELINE ERROR",
                //     error
                // );

            });

    };

    const getbusinessCategory = () => {

        b2bleadService
            .businessCategory()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setBusinessCategoryOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "BUSINESS CATEGORY ERROR",
                //     error
                // );

            });

    };

    const getshippingParnter = () => {

        b2bleadService
            .shippingPartner()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setShippingPartnerOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "SHIPPING PARTNER ERROR",
                //     error
                // );

            });

    };

    const getshipmentPotenical = () => {

        b2bleadService
            .shipmentpotencialOptions()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setShipmentPotentialOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "SHIPMENT POTENTIAL ERROR",
                //     error
                // );

            });

    };

    const getclientpersona = () => {

        b2bleadService
            .clientPersona()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setClientPersonaOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "CLIENT PERSONA ERROR",
                //     error
                // );

            });

    };

    const getleadOwner = () => {

        b2bleadService
            .leadOwner()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value: item?.id || item?.employeeId,

                    }));

                setLeadOwnerOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "LEAD OWNER ERROR",
                //     error
                // );

            });

    };





    const getutmfilter = () => {

        b2bleadService
            .utmFilters()
            .then((res) => {

                const leads =
                    res?.data?.data?.leads || [];

                // REMOVE EMPTY + DUPLICATES
                const source = [
                    ...new Set(
                        leads
                            .map((i) =>
                                i?.utmSource?.trim()
                            )
                            .filter((v) => v)
                    ),
                ];

                const medium = [
                    ...new Set(
                        leads
                            .map((i) =>
                                i?.utmMedium?.trim()
                            )
                            .filter((v) => v)
                    ),
                ];

                const campaign = [
                    ...new Set(
                        leads
                            .map((i) =>
                                i?.utmCampaign?.trim()
                            )
                            .filter((v) => v)
                    ),
                ];

                // SET OPTIONS
                setUtmSourceOptions(
                    source.map((i) => ({
                        label: i,
                        value: i,
                    }))
                );

                setUtmMediumOptions(
                    medium.map((i) => ({
                        label: i,
                        value: i,
                    }))
                );

                setUtmCampaignOptions(
                    campaign.map((i) => ({
                        label: i,
                        value: i,
                    }))
                );

            })
            .catch((error) => {

                // console.log(
                //     "UTM FILTER ERROR",
                //     error
                // );

            });

    };
    const getkyc = () => {

        b2bleadService
            .kycdone()

            .then((res) => {

                const data =
                    res?.data?.data || [];

                const formattedOptions =
                    data.map((item) => ({

                        label:
                            item?.name ||
                            item?.masterName,

                        value:
                            item?.name ||
                            item?.masterName,

                    }));

                setKycOptions(
                    formattedOptions
                );

            })

            .catch((error) => {

                // console.log(
                //     "KYC ERROR",
                //     error
                // );

            });

    };


    // for search 

    const sanitizeInput = (value, isPaste = false) => {
        if (!value) return "";

        // Convert spaces/new lines/tabs → comma
        if (isPaste) {
            value = value.replace(/[\s\n\t]+/g, ",");
        }

        // Allow only letters, numbers, @ . comma and spaces
        value = value.replace(/[^a-zA-Z0-9,@.\s]/g, "");

        // Replace multiple commas with single comma
        value = value.replace(/,+/g, ",");

        // Remove leading commas
        value = value.replace(/^,+/, "");

        return value;
    };


    return (

        <div className="page">
            <TopHeader />
            <Prince />

            <div className="main-content pt-0">
                <div className="container-fluid">

                    {/* HEADER */}
                    <div className="d-flex justify-content-between align-items-center my-3">
                        <h4>All Leads</h4>


                        <button
                            className="btn btn-sm btn-primary "
                            onClick={() => addLeadModalRef.current?.toggle()}
                        >
                            <i className="fa fa-plus me-1"></i>
                            Add New Lead
                        </button>
                    </div>

                    {/* FILTER CARD */}
                    <div className="card border-0 shadow-sm rounded-4 ">

                        {/* HEADER */}
                        <div
                            className="card-header bg-white border-0 px-3 py-3"
                            style={{
                                borderBottom: "1px solid #f1f1f1",
                            }}
                        >

                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                {/* LEFT */}
                                <div className="d-flex align-items-center gap-2">

                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            background: "#e7f1ff",
                                        }}
                                    >
                                        <i className="fa fa-filter text-primary small"></i>
                                    </div>

                                    <div>
                                        <h6 className="mb-0 fw-bold">
                                            Lead Filters
                                        </h6>

                                        <small className="text-muted">
                                            Filter CRM leads
                                        </small>
                                    </div>

                                </div>

                                {/* RIGHT */}
                                <button
                                    className="btn btn-sm btn-light rounded-pill px-3 shadow-sm"
                                    onClick={() => setShowFilters(!showFilters)}
                                >
                                    <i
                                        className={`fa me-1 ${showFilters
                                            ? "fa-chevron-up"
                                            : "fa-chevron-down"
                                            }`}
                                    ></i>

                                    {showFilters ? "Hide" : "Show"}
                                </button>

                            </div>

                        </div>

                        {/* BODY */}
                        {showFilters && (

                            <div className="card-body p-3">

                                <div className="row g-3">

                                    {/* SEARCH */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Search
                                        </label>

                                        <div className="input-group input-group-sm">

                                            <span className="input-group-text bg-white">
                                                <i className="fa fa-search text-muted"></i>
                                            </span>

                                            <input
                                                type="text"
                                                className="form-control shadow-none"
                                                style={{ height: "40px" }}
                                                placeholder="Search by id, companyId, mob no, email"
                                                value={filters.search || ""}

                                                // SPACE → comma
                                                onKeyDown={(e) => {
                                                    if (e.key === " " && e.target.value.trim() !== "") {
                                                        e.preventDefault();

                                                        setFilters((prev) => ({
                                                            ...prev,
                                                            search:
                                                                (prev.search || "").replace(/,+$/, "") + ",",
                                                        }));
                                                    }
                                                }}

                                                // Typing handler
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    value = sanitizeInput(value);

                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        search: value,
                                                    }));
                                                }}

                                                // Paste handler
                                                onPaste={(e) => {
                                                    e.preventDefault();

                                                    let pastedValue =
                                                        e.clipboardData.getData("text");

                                                    pastedValue = sanitizeInput(
                                                        pastedValue,
                                                        true
                                                    );

                                                    setFilters((prev) => {
                                                        let existing = prev.search || "";

                                                        let newValue = existing
                                                            ? existing.replace(/,+$/, "") +
                                                            "," +
                                                            pastedValue
                                                            : pastedValue;

                                                        return {
                                                            ...prev,
                                                            search: newValue,
                                                        };
                                                    });
                                                }}
                                            />

                                        </div>

                                    </div>
                                    {/* DATE */}
                                    <div className="col-12 col-md-3">

                                        <DateFormatter
                                            setDateForApi={(date) =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    from: date.from,
                                                    to: date.to,
                                                }))
                                            }
                                            clearDate={clearDate}
                                        />

                                    </div>

                                    {/* ACCOUNT TYPE */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Account Type
                                        </label>

                                        <Select
                                            classNamePrefix="react-select"
                                            options={[
                                                { value: "B2B", label: "B2B" },
                                                // { value: "B2C", label: "B2C" },
                                                { value: "BOTH", label: "BOTH" }
                                            ]}
                                            isClearable
                                            value={
                                                filters.accountType
                                                    ? {
                                                        value: filters.accountType,
                                                        label: filters.accountType,
                                                    }
                                                    : null
                                            }
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    accountType: selected?.value || "",
                                                })
                                            }
                                        />

                                    </div>

                                    {/* LEAD TYPE */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Lead Type
                                        </label>

                                        <Select
                                            classNamePrefix="react-select"
                                            options={[
                                                { value: "Hot", label: "Hot" },
                                                { value: "Warm", label: "Warm" },
                                                { value: "Cold", label: "Cold" },
                                            ]}
                                            isClearable
                                            value={
                                                filters.leadType
                                                    ? {
                                                        value: filters.leadType,
                                                        label: filters.leadType,
                                                    }
                                                    : null
                                            }
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    leadType: selected?.value || "",
                                                })
                                            }
                                        />

                                    </div>

                                    {/* LEAD SOURCE */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Lead Source
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={leadSourceOptions}
                                            value={filters.leadSource}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    leadSource: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* PIPELINE */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Lead Pipeline
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={leadPipelineOptions}
                                            value={filters.leadPipeline}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    leadPipeline: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* BUSINESS CATEGORY */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Business Category
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={businessCategoryOptions}
                                            value={filters.businessCategory}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    businessCategory: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* SHIPPING PARTNER */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Shipping Partner
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={shippingPartnerOptions}
                                            value={filters.currentShippingPartner}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    currentShippingPartner: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* SHIPMENT POTENTIAL */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Shipment Potential
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={shipmentPotentialOptions}
                                            value={filters.shipmentPotential}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    shipmentPotential: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* CLIENT PERSONA */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Client Persona
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={clientPersonaOptions}
                                            value={filters.clientPersona}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    clientPersona: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* LEAD OWNER */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Lead Owner
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={leadOwnerOptions}
                                            value={filters.employeeId}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    employeeId: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* KYC */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            KYC
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={kycOptions}
                                            value={filters.isKycDone}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    isKycDone: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* UTM SOURCE */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            UTM Source
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={utmSourceOptions}
                                            value={filters.utmSource}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    utmSource: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* UTM MEDIUM */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            UTM Medium
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={utmMediumOptions}
                                            value={filters.utmMedium}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    utmMedium: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* UTM CAMPAIGN */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            UTM Campaign
                                        </label>

                                        <Select
                                            isMulti
                                            classNamePrefix="react-select"
                                            options={utmCampaignOptions}
                                            value={filters.utmCampaign}
                                            onChange={(selected) =>
                                                setFilters({
                                                    ...filters,
                                                    utmCampaign: selected || [],
                                                })
                                            }
                                            placeholder="Select"
                                        />

                                    </div>

                                    {/* MIN SHIPMENT */}
                                    <div className="col-12 col-md-3">

                                        <label className="form-label small fw-semibold mb-1">
                                            Minimum Shipment
                                        </label>

                                        <input
                                            type="number"
                                            className="form-control form-control-sm shadow-none"
                                            style={{ height: "40px" }}
                                            placeholder="Shipment"
                                            value={filters.minimumExpectedShipmentToFship}
                                            onChange={(e) =>
                                                setFilters({
                                                    ...filters,
                                                    minimumExpectedShipmentToFship: e.target.value,
                                                })
                                            }
                                        />

                                    </div>

                                    {/* CHECKBOX */}
                                    <div className="col-12 col-md-3 d-flex align-items-end">

                                        <div className="form-check">

                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="disableGenericEmail"
                                                checked={filters.genericEmailPattern}
                                                onChange={(e) =>
                                                    setFilters({
                                                        ...filters,
                                                        genericEmailPattern: e.target.checked,
                                                    })
                                                }
                                            />

                                            <label
                                                className="form-check-label small fw-semibold"
                                                htmlFor="disableGenericEmail"
                                            >
                                                Disable Generic Email
                                            </label>

                                        </div>

                                    </div>

                                </div>

                                {/* BUTTONS */}
                                <div className="d-flex justify-content-end gap-2 mt-4 flex-wrap">

                                    <button
                                        className="btn btn-sm btn-primary rounded-pill px-3 shadow-sm"
                                        onClick={handleApplyFilter}
                                    >
                                        <i className="fa fa-filter me-1"></i>
                                        Apply
                                    </button>

                                    <button
                                        className="btn btn-sm btn-light border rounded-pill px-3"
                                        onClick={handleClearFilter}
                                    >
                                        Clear
                                    </button>

                                </div>

                            </div>

                        )}

                    </div>

                    {/* DATA SECTION */}
                    <div className="card shadow-sm mt-3 position-relative">

                        {/* LOADER OVERLAY */}
                        {loader && (
                            <div className="loading-overlay">
                                <img
                                    src={Loader}
                                    alt="Loading..."
                                // style={{
                                //     width: "120px",
                                //     height: "120px",
                                //     objectFit: "contain",
                                // }}
                                />
                            </div>
                        )}

                        <div className="card-body">

                            {/* TOP BAR */}
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">

                                {/* LEFT */}
                                <div className="d-flex align-items-center gap-2 flex-nowrap overflow-auto">

                                    <button className="btn btn-sm btn-primary rounded-pill">
                                        Total: {totalCount || 0}
                                    </button>

                                    {selectedLeads.length > 0 && (
                                        <button className="btn btn-sm btn-light rounded-pill">
                                            Selected: {selectedLeads.length}
                                        </button>
                                    )}

                                </div>

                                {/* RIGHT */}
                                <div className="d-flex align-items-center gap-2">

                                    <button
                                        className="btn btn-sm rounded-pill btn-info"
                                        disabled={selectedLeads.length === 0}
                                        onClick={() =>
                                            bulkAssignModalRef.current?.toggle()
                                        }
                                    >
                                        Bulk Assign
                                    </button>

                                    <button
                                        className="btn btn-sm rounded-pill btn-danger"
                                        disabled={selectedLeads.length === 0}
                                        onClick={() =>
                                            bulkleadsourceModalRef.current?.toggle()
                                        }
                                    >
                                        Bulk Source
                                    </button>

                                    <button
                                        className="btn btn-sm rounded-pill btn-success"
                                        disabled={selectedLeads.length === 0}
                                        onClick={() =>
                                            bulkstageModalRef.current?.toggle()
                                        }
                                    >
                                        Bulk Stage
                                    </button>

                                    <button
                                        className="btn btn-sm rounded-pill btn-warning"
                                        disabled={selectedLeads.length === 0}
                                        onClick={() =>
                                            bulkpipelineModalRef.current?.toggle()
                                        }
                                    >
                                        Bulk Pipeline
                                    </button>

                                    {canExport && (
                                        <button
                                            className="btn btn-sm rounded-pill btn-primary"
                                            onClick={() =>
                                                b2cexportModalRef.current?.toggle()
                                            }
                                        >
                                            <i className="fa fa-download me-1"></i>
                                            Export
                                        </button>
                                    )}

                                </div>

                            </div>

                            <hr />

                            {/* TABS */}
                            <div style={{ overflowX: "auto" }}>
                                <ul
                                    className="nav nav-pills flex-nowrap gap-2 rounded-pills"
                                    style={{
                                        overflowX: "auto",
                                        whiteSpace: "nowrap",
                                    }}
                                >

                                    {tabs.map((tab) => (

                                        <button
                                            style={{ flexShrink: 0 }}
                                            key={tab.value}
                                            onClick={() => {

                                                setActiveTab(tab.value);
                                                setCurrentPage(1);

                                            }}
                                            className={`btn btn-sm ${activeTab === tab.value
                                                ? "btn-primary"
                                                : "btn-light border"
                                                }`}
                                        >

                                            {tab.label}

                                        </button>

                                    ))}

                                </ul>
                            </div>

                            {/* TABLE */}
                            <div
                                className="table-responsive mt-3 rounded-4 shadow-sm border"
                                style={{
                                    overflowX: "auto",
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >

                                <table
                                    className="table align-middle mb-0"
                                    style={{
                                        minWidth: "1200px",
                                    }}
                                >

                                    {/* HEADER */}
                                    <thead
                                        style={{
                                            background: "#f8fafc",
                                        }}
                                    >

                                        <tr className="text-center text-uppercase small text-muted">

                                            <th
                                                className="align-middle border-end"
                                                style={{
                                                    minWidth: "60px",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    onChange={handleSelectAll}
                                                    checked={
                                                        tableData.length > 0 &&
                                                        selectedLeads.length === tableData.length
                                                    }
                                                />
                                            </th>

                                            <th className="border-end fw-bold">ID</th>

                                            <th className="border-end fw-bold">
                                                Source Details
                                            </th>

                                            <th className="border-end fw-bold">
                                                Assigned To
                                            </th>

                                            <th className="border-end fw-bold">
                                                Client Info
                                            </th>

                                            <th className="border-end fw-bold">
                                                Company Info
                                            </th>

                                            <th className="fw-bold">
                                                Actions
                                            </th>

                                        </tr>

                                    </thead>

                                    {/* BODY */}
                                    <tbody>

                                        {!loader && tableData?.length > 0 ? (

                                            tableData.map((item) => (

                                                <tr
                                                    key={item.id}
                                                    className="border-top"
                                                >

                                                    {/* CHECKBOX */}
                                                    <td className="text-center border-end align-middle">

                                                        <input
                                                            type="checkbox"
                                                            checked={selectedLeads.includes(item.id)}
                                                            onChange={(e) =>
                                                                handleCheckboxChange(e, item.id)
                                                            }
                                                        />

                                                    </td>

                                                    {/* ID */}
                                                    <td className="border-end text-center align-middle">

                                                        <div className="fw-bold text-primary fs-6">
                                                            LD-{item.id}
                                                        </div>

                                                        <small className="text-muted">
                                                            Lead ID
                                                        </small>

                                                    </td>

                                                    {/* SOURCE DETAILS */}
                                                    <td className="border-end">

                                                        <div className="small d-flex flex-column gap-1">

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Source:
                                                                </span>{" "}
                                                                {item.leadSource || "N/A"}
                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Status:
                                                                </span>{" "}

                                                                <span className="badge bg-primary-subtle text-primary">
                                                                    {item.masterStatus || "N/A"}
                                                                </span>

                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Stage:
                                                                </span>{" "}

                                                                <span className="badge bg-success-subtle text-success">
                                                                    {item.status || "N/A"}
                                                                </span>

                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Pipeline:
                                                                </span>{" "}
                                                                {item.leadPipeline || "N/A"}
                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Company ID:
                                                                </span>{" "}
                                                                {item.companyId || "N/A"}
                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    KYC:
                                                                </span>{" "}
                                                                {item.isKycDone || "N/A"}
                                                            </div>

                                                            <div>
                                                                <span className="fw-semibold">
                                                                    Added:
                                                                </span>{" "}

                                                                  {item.createdAt || "N/A"}

                                                                {/* {item.createdAt
                                                                    ? new Date(item.createdAt)
                                                                        .toISOString()
                                                                        .replace("T", " ")
                                                                        .slice(0, 19)
                                                                    : "N/A"} */}
                                                            </div>

                                                        </div>

                                                    </td>

                                                    {/* ASSIGNED */}
                                                    <td className="border-end text-center align-middle">

                                                        <div
                                                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold"
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            {item.assignedTo
                                                                ?.trim()
                                                                ?.charAt(0)
                                                                ?.toUpperCase() || "U"}
                                                        </div>

                                                        <div className="mt-2 fw-semibold small">
                                                            {item.assignedTo || "Unassigned"}
                                                        </div>

                                                    </td>

                                                    {/* CLIENT INFO */}
                                                    <td className="border-end">

                                                        <div className="small d-flex flex-column gap-1">

                                                            <div className="fw-semibold text-dark">
                                                                {item.primaryContactName || "N/A"}
                                                            </div>

                                                            <div>
                                                                <i className="fa fa-envelope text-muted me-1"></i>

                                                                {item.emailId || "N/A"}
                                                            </div>

                                                            <div>
                                                                <i className="fa fa-phone text-muted me-1"></i>

                                                                {item.mobileNumber || "N/A"}
                                                            </div>

                                                            <div className="d-flex flex-wrap gap-1 mt-1">

                                                                <span className="badge bg-info-subtle text-info">
                                                                    {item.accountType || "N/A"}
                                                                </span>

                                                                <span className="badge bg-danger-subtle text-danger">
                                                                    {item.leadType || "N/A"}
                                                                </span>

                                                            </div>

                                                        </div>

                                                    </td>

                                                    {/* COMPANY INFO */}
                                                    <td className="border-end">

                                                        <div className="small d-flex flex-column gap-1">

                                                            <div className="fw-semibold text-dark">
                                                                {item.companyName || "N/A"}
                                                            </div>

                                                            <div>
                                                                Category:{" "}
                                                                {item.businessCategory || "N/A"}
                                                            </div>

                                                            <div>
                                                                Partner:{" "}
                                                                {item.currentShippingPartner || "N/A"}
                                                            </div>

                                                            <div>
                                                                Shipment:{" "}
                                                                {item.shipmentPotential || "N/A"}
                                                            </div>

                                                            <div>
                                                                Min ES:{" "}
                                                                {item.minimumExpectedShipmentToFship || "N/A"}
                                                            </div>

                                                            <div>
                                                                Persona:{" "}
                                                                {item.clientPersona || "N/A"}
                                                            </div>

                                                            <div
                                                                className="text-truncate"
                                                                style={{
                                                                    maxWidth: "250px",
                                                                }}
                                                            >
                                                                <span className="fw-semibold">
                                                                    UTM:
                                                                </span>{" "}

                                                                {`${item.utmSource || ""} -
                            ${item.utmMedium || ""} -
                            ${item.utmCampaign || ""}`}
                                                            </div>

                                                        </div>

                                                    </td>

                                                    {/* ACTION */}
                                                    <td className="text-center align-middle">

                                                        <div className="dropdown d-flex justify-content-center">

                                                            <button
                                                                className="btn btn-primary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                style={{
                                                                    width: "38px",
                                                                    height: "38px",
                                                                }}
                                                            >
                                                                <i className="fa fa-ellipsis-v"></i>
                                                            </button>

                                                            <ul
                                                                className="dropdown-menu dropdown-menu-end shadow border-0 rounded-4 p-2"
                                                                style={{
                                                                    minWidth: "220px",
                                                                }}
                                                            >

                                                                <li>



                                                                    <button
                                                                        key={item.id}
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            navigate(
                                                                                `/b2b/lead/activity/${item.id}`,
                                                                                {
                                                                                    state: {
                                                                                        previousTab: activeTab,
                                                                                        filters: filters,
                                                                                    },
                                                                                }
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="fa fa-history text-warning me-2"></i>

                                                                        Activity

                                                                    </button>



                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            navigate(`/b2b/lead/contact/${item.id}`)
                                                                        }
                                                                    >
                                                                        <i className="fa fa-address-book text-danger me-2"></i>

                                                                        Contacts

                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            editLeadModalRef.current?.toggle(item)
                                                                        }
                                                                    >
                                                                        <i className="fa fa-edit text-success me-2"></i>
                                                                        Edit Lead
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            assignModalRef.current?.toggle(item.id)
                                                                        }
                                                                    >
                                                                        <i className="fa fa-user-plus text-info me-2"></i>
                                                                        Assign
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            stageModalRef.current?.toggle(item.id, item.status)
                                                                        }
                                                                    >
                                                                        <i className="fa fa-layer-group text-warning me-2"></i>
                                                                        Stage
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item rounded-3 py-2"
                                                                        onClick={() =>
                                                                            leadlifecycleModalRef.current?.toggle(item.id)
                                                                        }
                                                                    >
                                                                        <i className="fa fa-chart-line text-secondary me-2"></i>
                                                                        Lead Lifecycle
                                                                    </button>
                                                                </li>

                                                                {item.masterStatus === "Won" &&
                                                                    !item.isCustomer && (

                                                                        <li>

                                                                            <button
                                                                                className="dropdown-item rounded-3 py-2"
                                                                                onClick={() =>
                                                                                    assigntokamRef.current?.toggle(item.id)
                                                                                }
                                                                            >

                                                                                <i className="fa fa-user-tie text-primary me-2"></i>

                                                                                Assign to KAM

                                                                            </button>

                                                                        </li>

                                                                    )}

                                                            </ul>

                                                        </div>

                                                    </td>

                                                </tr>

                                            ))

                                        ) : !loader && tableData?.length === 0 ? (

                                            <tr>

                                                <td
                                                    colSpan="7"
                                                    className="text-center py-5"
                                                >

                                                    <div className="d-flex flex-column align-items-center">

                                                        <h5 className="fw-bold mb-1">
                                                            No Leads Available
                                                        </h5>

                                                    </div>

                                                </td>

                                            </tr>

                                        ) : null}

                                    </tbody>

                                </table>

                            </div>

                            {/* PAGINATION */}
                            {!loader && (
                                <TablePagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    pageSize={pageSize}
                                    handlePageChange={handlePageChange}
                                    handlePageSize={handlePageSize}
                                />
                            )}

                        </div>

                    </div>


                </div>
            </div>

            <AddB2BLeadModal ref={addLeadModalRef} getLeadData={getLeadData} />
            <B2BAssignToKamModel ref={assigntokamRef} getLeadData={getLeadData} />
            <B2BBulkAssignModal
                ref={bulkAssignModalRef}
                selectedLeads={selectedLeads}
                getLeadData={getLeadData}
                setSelectedLeads={setSelectedLeads}
            />

            <B2BBulkLeadSoureModal
                ref={bulkleadsourceModalRef}
                selectedLeads={selectedLeads}
                getLeadData={getLeadData}
                setSelectedLeads={setSelectedLeads}
            />
            <B2BBulkStageModal
                ref={bulkstageModalRef}
                selectedLeads={selectedLeads}
                getLeadData={getLeadData}
                setSelectedLeads={setSelectedLeads}
            />

            <B2BBulkPipelineModal
                ref={bulkpipelineModalRef}
                selectedLeads={selectedLeads}
                getLeadData={getLeadData}
                setSelectedLeads={setSelectedLeads}
            />
            <EditB2BLeadModal
                ref={editLeadModalRef}
                // selectedLeads={selectedLeads}
                getLeadData={getLeadData}
            // setSelectedLeads={setSelectedLeads}
            />
            <B2BAssignModal
                ref={assignModalRef}
                selectedLeads={selectedLeads}
                getLeadData={getLeadData}
                setSelectedLeads={setSelectedLeads}
            />
            <B2BLeadLifeCycleModal
                ref={leadlifecycleModalRef}
                getLeadData={getLeadData}
            />
            <B2BStageModal
                ref={stageModalRef}
                getLeadData={getLeadData}
            />
            <B2BExportModalComponent
                ref={b2cexportModalRef}
                filters={filters}
                page={currentPage}
                pageSize={pageSize}
                status={activeTab}
            />



            <div className="main-footer text-center mt-4">

                <div className="container">

                    <div className="col-md-12">

                        <span>
                            Copyright © 2024{" "}

                            <a href="/">
                                FSHIP
                            </a>

                            . Developed by{" "}

                            <a href="http://fship.in/">
                                FSHIP
                            </a>{" "}

                            All rights reserved.
                        </span>

                    </div>

                </div>

            </div>
        </div>

    );
};